export function fmtDate(val: string | number | Date | null | undefined): string {
  if (val == null || val === '') return '—';
  const d = typeof val === 'number' && val < 1e10
    ? new Date(val * 1000)
    : new Date(val as string | number | Date);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-AU');
}

export function fmtDateTime(val: string | number | Date | null | undefined): string {
  if (val == null || val === '') return '—';
  const d = typeof val === 'number' && val < 1e10
    ? new Date(val * 1000)
    : new Date(val as string | number | Date);
  if (isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-AU');
  const time = d.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${date} ${time}`;
}
